<template>
  <div class="@container/main flex flex-1 flex-col gap-2 -mx-4 lg:-mx-6">
    <div class="flex flex-col gap-4 pb-4 md:gap-6 md:pb-6">
      <SectionCards />

      <Tabs v-model="tab" class="px-4 lg:px-6">
        <TabsList class="mb-4">
          <TabsTrigger value="cashback">Cashback</TabsTrigger>
          <TabsTrigger value="perks">Perks</TabsTrigger>
        </TabsList>

        <TabsContent value="cashback" class="flex flex-col gap-4 md:gap-6">
          <ChartAreaInteractive />
          <div class="flex flex-col gap-4 @4xl/main:flex-row @4xl/main:items-stretch">
            <div class="min-w-0 @4xl/main:w-1/2">
              <DataTable />
            </div>
            <div class="min-w-0 @4xl/main:w-1/2">
              <OffersToActivate />
            </div>
          </div>
        </TabsContent>

        <TabsContent value="perks">
          <PerksTab />
        </TabsContent>
      </Tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@boogi/ui'
import SectionCards from './SectionCards.vue'
import ChartAreaInteractive from './ChartAreaInteractive.vue'
import DataTable from './DataTable.vue'
import OffersToActivate from './OffersToActivate.vue'
import PerksTab from './PerksTab.vue'

export default {
  name: 'DashboardHome',
  components: {
    Tabs,
    TabsList,
    TabsTrigger,
    TabsContent,
    SectionCards,
    ChartAreaInteractive,
    DataTable,
    OffersToActivate,
    PerksTab,
  },
  data() {
    return {
      tab: 'cashback',
    }
  },
}
</script>
